import React, { useState } from "react";
import { FaCalendarAlt, FaClock, FaCar, FaSave, FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import axiosInstance from "../config/axiosInstance";
import API from "../config/config";

const UpdateRideStartedAt = () => {
  const [formData, setFormData] = useState({
    rideId: "",
    newStartDate: "",
    newStartTime: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.rideId.trim() || !formData.newStartDate || !formData.newStartTime) {
      toast.error("Please fill ride ID, date, and time.");
      return;
    }

    setSubmitting(true);
    try {
      const payload = {
        rideId: formData.rideId.trim(),
        newStartDate: formData.newStartDate,
        newStartTime: formData.newStartTime,
      };

      const response = await axiosInstance.post(API.ADMIN.RIDE_TEST_UPDATE_STARTED_AT, payload);

      if (response?.data?.success) {
        toast.success(response.data.message || "Ride start time updated successfully.");
      } else {
        toast.success("Ride start time update request sent.");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to update ride start time.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="max-w-2xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Update Ride Start Time</h1>
          <p className="text-gray-600">
            Update ride start date and time by entering ride ID and selecting the new values.
          </p>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Ride ID</label>
              <div className="relative">
                <FaCar className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  value={formData.rideId}
                  onChange={(e) => handleChange("rideId", e.target.value)}
                  placeholder="Enter ride ID (e.g. 69d8e1285f5db7c92ca185bf)"
                  className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">New Start Date</label>
              <div className="relative">
                <FaCalendarAlt className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="date"
                  value={formData.newStartDate}
                  onChange={(e) => handleChange("newStartDate", e.target.value)}
                  className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">New Start Time</label>
              <div className="relative">
                <FaClock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="time"
                  value={formData.newStartTime}
                  onChange={(e) => handleChange("newStartTime", e.target.value)}
                  className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={submitting}
              className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {submitting ? <FaSpinner className="animate-spin mr-2" /> : <FaSave className="mr-2" />}
              {submitting ? "Updating..." : "Update Ride Start Time"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UpdateRideStartedAt;
